export default __webpack_public_path__ + "static/media/flash-hider.cda3524b.svg";